// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.argyle-data,
.identity-data {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding-top: 20px;
}
.argyle-data table,
.identity-data table {
  width: 99%;
}
.argyle-data table th,
.identity-data table th,
.argyle-data table td,
.identity-data table td {
  text-align: center;
}
.filter-title {
  border-bottom-color: #d8d9ea;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
h3.filter-title {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fa-rotate-daveRocks:before {
  content: "\\f2f1";
}
form {
  padding-bottom: none !important;
}
.wizard-drafts-summary {
  padding: 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
}
.wizard-drafts-total {
  padding: 8px 15px;
  font-size: 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 4px;
  margin-bottom: 10px;
}
.wizard-drafts-total strong {
  font-size: 16px;
}
.wizard-drafts-counts {
  color: #6c757d;
  font-size: 12px;
  margin-left: 8px;
}
.wizard-drafts-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}
.wizard-drafts-table th {
  background: #e1dbe2;
  padding: 6px 10px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
}
.wizard-drafts-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #ededed;
  text-align: left;
}
.wizard-drafts-table tr.draft-included td {
  background: #fafffe;
}
.wizard-drafts-table tr.draft-excluded td {
  background: #fefafa;
  color: #6c757d;
}
.wizard-drafts-excluded th {
  background: #f5f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/argyle/argyle.component.less"],"names":[],"mappings":"AAEA;;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;AAAJ;AAPA;;EASQ,UAAA;AAER;AAXA;;;;EAYY,kBAAA;AAKZ;AAAA;EACI,4BAAA;EACA,0BAAA;EACA,wBAAA;AAEJ;AACA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEA;EACI,gBAAA;AAAJ;AAEI;EACI,+BAAA;AAAR;AAIA;EACE,aAAA;EACA,iBAAA;EACA,gCAAA;AAFF;AAKA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAHA;EAQW,eAAA;AAFX;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAMA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;AAJF;AACA;EAMI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAJJ;AANA;EAcI,iBAAA;EACA,gCAAA;EACA,gBAAA;AALJ;AAXA;EAmByB,mBAAA;AALzB;AAdA;EAoByB,mBAAA;EAAqB,cAAA;AAF9C;AAKA;EACO,mBAAA;AAHP","sourcesContent":["@import (reference) url('../../../../styles.less');\n\n.argyle-data,.identity-data{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid @h1-bottom;\n    padding-top: 20px;\n    table{\n        width: 99%;     \n        th, td{\n            // border: 1px solid;\n            text-align: center;\n        }\n    }\n}\n\n.filter-title{\n    border-bottom-color:rgb(216, 217, 234);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\nh3.filter-title{\n    background: rgb(225,219,226);\n    margin: 0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.fa-rotate-daveRocks:before {\n    content: \"\\f2f1\"; }\n  \n    form{\n        padding-bottom: none !important;\n    }\n\n// ── Wizard Draft Sources Summary ──\n.wizard-drafts-summary {\n  padding: 10px;\n  background: white;\n  border-bottom: 1px solid rgb(216, 217, 234);\n}\n\n.wizard-drafts-total {\n  padding: 8px 15px;\n  font-size: 14px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 4px;\n  margin-bottom: 10px;\n\n  strong { font-size: 16px; }\n}\n\n.wizard-drafts-counts {\n  color: #6c757d;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n.wizard-drafts-table {\n  width: 100%;\n  font-size: 13px;\n  border-collapse: collapse;\n\n  th {\n    background: rgb(225, 219, 226);\n    padding: 6px 10px;\n    text-align: left;\n    font-weight: 600;\n    font-size: 12px;\n  }\n\n  td {\n    padding: 6px 10px;\n    border-bottom: 1px solid #ededed;\n    text-align: left;\n  }\n\n  tr.draft-included td { background: #fafffe; }\n  tr.draft-excluded td { background: #fefafa; color: #6c757d; }\n}\n\n.wizard-drafts-excluded {\n  th { background: #f5f0f0; }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
